import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="base" title="Preguntas frecuentes" data-id="element-47" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-narrow space-y-3" data-id="element-48" data-mp="1ge8u4k5d09qw">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-night-700 ring-1 ring-white/5" data-id="element-49" data-mp="291mlm2qagd3m" data-mpi={index}>
              <h3 data-id="element-50" data-mp="240p5rwsr3v5a">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-calm hover:bg-night-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/60 md:px-7" data-id="element-51" data-mp="24436l0lrnwam">
                  <span className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-52" data-mp="ugr7sshjkskk">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold-400 transition-transform duration-200 ease-calm ${isOpen ? 'rotate-45' : ''}`} strokeWidth={1.75} aria-hidden="true" data-id="element-53" data-mp="fji9fettmojc" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-54" data-mp="3sz6gtx7xgplg">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-55" data-mp="1sd5w1nc1c3q">
                    <p className="px-5 pb-6 text-lg text-muted md:px-7" data-id="element-56" data-mp="1uhmjfahsefif">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}